import { Theme } from '@mui/material/styles';
import dayjs from 'dayjs';

import { JobEtaBasic } from '~hooks/useJob/models';
import { Nullable } from '~types/Nullable';

import { etaTone } from './etaFormat';

/**
 * The row background for a job's ETA severity — `undefined` for anything neutral, so
 * untracked and on-time rows stay exactly as they were.
 *
 * Dwell is measured against a plain `dayjs()` read rather than the one-second ticker behind
 * the ETA cell, because a ticking tint would re-render the whole table every second. A row
 * therefore takes its new tint on the table's next render, not the second a threshold
 * passes.
 */
export function etaRowTintBgcolor(theme: Theme, eta: Nullable<JobEtaBasic>) {
  if (!eta) return undefined;

  const tone = etaTone(eta, dayjs());

  if (tone === 'critical') {
    return theme.semantic.rowCriticalBg;
  }

  if (tone === 'warning') {
    return theme.semantic.rowWarningBg;
  }

  return undefined;
}
